import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
import { UserAcitivtyRequestData } from "../../types/UserActivityRequestData";

const baseUrl = process.env.REACT_APP_API_URL;
const UserActivityUrl = urlConfig.GetUserAcitivty;
const documentViewerUrl = urlConfig.documentViewer;



export const getUserActivityData = async (documentsModel: UserAcitivtyRequestData) => {
    try {
        const response = await postCall(UserActivityUrl, documentsModel);
        return response.data;
    } catch (error) {
        console.error("Error fetching data", error);
        throw error;
    }
};


